// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BsModalController from "./bs_modal_controller"
application.register("bs-modal", BsModalController)

import CollectionSelectController from "./collection_select_controller"
application.register("collection-select", CollectionSelectController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RansackController from "./ransack_controller"
application.register("ransack", RansackController)

import SelectcheckController from "./selectcheck_controller"
application.register("selectcheck", SelectcheckController)

import UploadSelectorController from "./upload_selector_controller"
application.register("upload-selector", UploadSelectorController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import BulkActionsController from "./bulk_actions_controller"
application.register("bulk-actions", BulkActionsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import PassportNumberController from "./passport_number_controller"
application.register("passport-number", PassportNumberController)
